module.exports = __webpack_public_path__ + "img/c8.14c7adda.jpg";